const NAME_RE = /^[A-Za-z_][A-Za-z0-9_-]*$/;
export function tokenizeXPath(xpath) {
    if (!xpath.startsWith('/'))
        return { error: 'path must start with /' };
    if (xpath.startsWith('//'))
        return { error: 'descendant-axis not supported' };
    const raw = xpath.slice(1);
    if (raw.length === 0)
        return { error: 'empty path' };
    const segments = raw.split('/');
    const tokens = [];
    for (let i = 0; i < segments.length; i++) {
        const seg = segments[i];
        if (seg === undefined)
            continue;
        if (seg === '')
            return { error: 'empty segment' };
        if (seg === '*' || seg.includes('*'))
            return { error: 'wildcard not supported' };
        if (seg.includes(':'))
            return { error: 'namespaces not supported' };
        if (seg.startsWith('@')) {
            if (i !== segments.length - 1)
                return { error: 'attribute must be terminal segment' };
            const name = seg.slice(1);
            if (!NAME_RE.test(name))
                return { error: `invalid attribute name: ${name}` };
            tokens.push({ kind: 'attr', name });
            continue;
        }
        const match = seg.match(/^([A-Za-z_][A-Za-z0-9_-]*)(?:\[(\d+)\])?$/);
        if (!match)
            return { error: `invalid element segment: ${seg}` };
        const name = match[1];
        const idxStr = match[2];
        if (idxStr !== undefined) {
            const idx = Number(idxStr);
            if (idx < 1)
                return { error: 'positional index must be >= 1' };
            tokens.push({ kind: 'elem', name, index: idx });
        }
        else {
            tokens.push({ kind: 'elem', name });
        }
    }
    return { tokens };
}
//# sourceMappingURL=xml-grammar.js.map